export const Logo = ({ size = 30 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true" data-testid="brand-logo">
    <circle cx="32" cy="32" r="6" fill="#55d8e8" />
    <ellipse cx="32" cy="32" rx="25" ry="10.5" stroke="#4b91ff" strokeWidth="3" transform="rotate(-28 32 32)" />
    <ellipse cx="32" cy="32" rx="25" ry="10.5" stroke="#55d8e8" strokeWidth="3" opacity=".5" transform="rotate(28 32 32)" />
    <circle cx="53" cy="20.5" r="3.4" fill="#55d8e8" />
  </svg>
);
